import {
  fetchAppsStart,
  fetchAppsSuccess,
  fetchAppsFailure,
  setSelectedApp,
  setScripts,
} from '../slices/appRegistrySlice';
import appRegistryService from '../../services/api/appRegistryService';

export const fetchApps = () => async (dispatch) => {
  try {
    dispatch(fetchAppsStart());
    const response = await appRegistryService.getApps();
    dispatch(fetchAppsSuccess(response.data));
  } catch (error) {
    console.error('Error fetching apps:', error);
    dispatch(fetchAppsFailure(error.message || 'Failed to fetch apps'));
  }
};

export const fetchAppById = (id) => async (dispatch) => {
  try {
    dispatch(fetchAppsStart());
    const response = await appRegistryService.getApp(id);
    dispatch(setSelectedApp(response.data));
    return response.data;
  } catch (error) {
    console.error(`Error fetching app ${id}:`, error);
    dispatch(fetchAppsFailure(error.message || 'Failed to fetch app'));
    throw error;
  }
};

export const fetchScriptsForApp = (appId) => async (dispatch) => {
  try {
    const response = await appRegistryService.getScripts(appId);
    // Normalize: API may return an array or a wrapper object
    const data = response.data;
    const scripts = Array.isArray(data) ? data : Array.isArray(data?.scripts) ? data.scripts : Array.isArray(data?.data) ? data.data : [];
    dispatch(setScripts(scripts));
    return scripts;
  } catch (error) {
    console.error(`Error fetching scripts for app ${appId}:`, error);
    throw error;
  }
};

export const createApp = (data) => async (dispatch) => {
  try {
    const response = await appRegistryService.createApp(data);
    dispatch(fetchApps());
    return response.data;
  } catch (error) {
    console.error('Error creating app:', error);
    dispatch(fetchAppsFailure(error.message || 'Failed to create app'));
    throw error;
  }
};

export const updateApp = (id, data) => async (dispatch) => {
  try {
    const response = await appRegistryService.updateApp(id, data);
    dispatch(fetchApps());
    return response.data;
  } catch (error) {
    console.error('Error updating app:', error);
    dispatch(fetchAppsFailure(error.message || 'Failed to update app'));
    throw error;
  }
};
